
var stache = require('can/view/stache/stache');
module.exports = stache("<button class=\"{{className}} hero-swiper-pagination-button\"{{#if isActive}} aria-current=\"page\"{{/if}}>\r\n    <div>{{slideOptions.caption}}</div>\r\n</button>");